import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {Shape, TrackingChangeType} from 'diagram-js/lib/model';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';

export abstract class TrackingChangeBaseBehavior extends CommandInterceptor {
  protected constructor(protected eventBus: EventBus, protected moddle, protected modeling,
                        protected bpmnExtensionHelper: BpmnExtensionHelper) {
    super(eventBus);
  }

  abstract getChangeType(element?:Shape): TrackingChangeType;

  abstract extractElementsFromEvent(event): Array<Shape>;

  markElementForChange(event) {
    const elements = this.extractElementsFromEvent(event);
    elements.forEach(element => {
      const trackingChangeType = this.getChangeType(element);
      this.bpmnExtensionHelper.markElementForChange(element, trackingChangeType);
    });
  }

  postExecute(events, priority) {
    super.postExecute(events, priority);
  }

  postExecuted(events, priority) {
    super.postExecuted(events, priority);
  }


  preExecuted(events, priority) {
    super.preExecuted(events, priority);
  }
}

TrackingChangeBaseBehavior.$inject = [...CommandInterceptor.$inject, 'moddle', 'modeling', 'bpmnExtensionHelper'];
